export default [
    {
        path: '/services/disputes-litigation',
        name: 'services.disputes',
        component: () => import('@/views/dashboard/disputes/DisputesSummary.vue'),
        meta: { 
            service: 'disputes',
            smallMenu: true,
            active: 'disputes'
        },
    },

     // LEADS INDEX
     {
        path: '/services/disputes-litigation/leads',
        name: 'services.disputes.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: { 
            service: 'disputes',
            type: 'lead',
            smallMenu: true,
            active: 'disputes'
        },
    },
    // LEADS SINGLE
    {
        path: '/services/disputes-litigation/leads/view/:reference?',
        name: 'services.disputes.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'disputes',
            type: 'lead',
            smallMenu: true,
            active: 'disputes',
        }
    },

    // QUOTES INDEX
    {
        path: '/services/disputes-litigation/quotes',
        name: 'services.disputes.quotes',
        component: () => import('@/views/dashboard/disputes/DisputesQuotesIndex.vue'),
        meta: { 
            service: 'disputes',
            type: 'quote',
            smallMenu: true,
            active: 'disputes'
        },
    },
    // QUOTES SINGLE
    {
        path: '/services/disputes-litigation/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'disputes',
            type: 'quote',
            smallMenu: true,
            active: 'disputes'
        },
        children: [
            {
                path: '',
                name: 'services.disputes.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.disputes.quote.view.summary',
                component: () => import('@/components/dashboard/disputes/DisputesQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.disputes.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.disputes.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },

    // // MATTERS INDEX
    // {
    //     path: '/services/disputes/matters',
    //     name: 'services.disputes.matters',
    //     component: () => import('@/views/dashboard/disputes/DisputesMattersIndex.vue'),
    //     meta: { 
    //         service: 'disputes',
    //         type: 'matter',
    //         smallMenu: true,
    //         active: 'disputes'
    //     },
    // },
]